import { provenanceFooter } from '../../utils/provenance';
import '../../styles/EditCase.css';

export default function HPIContent({ hpiText, onCopy, copySuccess, generatedAt, signoff }) {
    if (!hpiText) return null;

    return (
        <div className="hpi-content-wrapper">
            <div className="document-toolbar">
                <button
                    type="button"
                    className={`copy-button ${copySuccess ? 'copied' : ''}`}
                    onClick={onCopy}
                >
                    {copySuccess ? '\u2713 Copied!' : 'Copy to Clipboard'}
                </button>
            </div>
            <div className="results-container">
                <div className="results-answer">
                    {hpiText}
                </div>
            </div>
            <p className="provenance-footer">{provenanceFooter({ generatedAt, signoff })}</p>
        </div>
    );
}
